import type {
  HighchartsElementDescriptor,
  HighchartsExporterFeatures,
} from './types';

// Reusable Export Image toggle lists for non-Wells Highcharts charts. Each `key`
// maps to an option mutation in the exporter; unknown keys are ignored (safe).

// Standard cartesian chart (line / column / bar / area / scatter): full toggle
// set including both axes.
export const GENERIC_CHART_ELEMENTS: HighchartsElementDescriptor[] = [
  { key: 'title', label: 'Title', available: true },
  { key: 'legend', label: 'Legend', available: true },
  { key: 'axisTitles', label: 'Axis Titles', available: true },
  { key: 'axisLabels', label: 'Axis Labels', available: true },
  { key: 'dataLabels', label: 'Data Labels', available: true },
];

// Pie / donut charts have no axes — expose only the toggles that apply.
export const PIE_CHART_ELEMENTS: HighchartsElementDescriptor[] = [
  { key: 'title', label: 'Title', available: true },
  { key: 'legend', label: 'Legend', available: true },
  { key: 'dataLabels', label: 'Data Labels', available: true },
];

// Column/bar/category charts opt out of sparse-tick recompute (it mangles category
// labels). Frozen for a stable identity so the exporter useMemo isn't busted.
export const CATEGORY_AXIS_FEATURES: HighchartsExporterFeatures = Object.freeze(
  {
    applySparseTicks: false,
  }
);
